import { setRumWhitelabel } from '@ringba/telemetry/rum';
import { fetchAndApplyWhitelabel, updateFavicon, applyTheme, hasCustomColorTheme } from '@ringba/whitelabel';

let _resolvedValue = null;

/** @type {boolean} Whether the WL theme has custom color overrides (incompatible with V3). */
let _hasCustomColors = false;

export const whitelabelManager = {
  get value() {
    return _resolvedValue;
  },
  get config() {
    return _resolvedValue?.config;
  },
  /** Whether the WL theme has custom color overrides incompatible with V3. Resolved from WL settings during Angular config phase. */
  get hasCustomColors() {
    return _hasCustomColors;
  },
  updateFavicon,
  applyTheme,
};

(function() {
  'use strict';

  // eslint-disable-next-line prefer-arrow-callback
  angular.module('ringbaPortal.services').config(function (
    cacheKey,
    wlSettings,
    ngAuthSettings,
  ) {

    _resolvedValue = fetchAndApplyWhitelabel({
      cacheKey: cacheKey + '_whitelabel',
      defaultBasePath: '/dashboard',
      settings: wlSettings,
      verbose: true,
      fetcher: async (friendlyName) => {
        try {
          const response = await fetch(`${ngAuthSettings.apiServiceBaseUri}wl/${friendlyName}/settings`);
          if (!response.ok) {
            return null;
          }

          return response.json();
        } catch (error) {
          console.error('Error fetching whitelabel settings:', error);
          return null;
        }
      },
    });

    setRumWhitelabel(_resolvedValue.friendlyName);

    _resolvedValue.config = wlSettings;

    // Resolve custom color theme check for V3 compatibility
    if (_resolvedValue.friendlyName && _resolvedValue.settings) {
      _resolvedValue.settings.then(settings => {
        _hasCustomColors = hasCustomColorTheme(settings);
        if (_hasCustomColors) {
          console.warn('[WL] V3 blocked: whitelabel has custom color theme');
        }
      }).catch(() => { /* keep _hasCustomColors = false */ });
    }
  });

  angular.module('ringbaPortal.services').constant('whitelabelManager', whitelabelManager);
})();
